import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { devConfig } from 'config/config'; // Importing development configuration from the config module

/**
 * Class representing a view for table expenses.
 * @extends JetView
 */
export default class tableExpensesView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        // Retrieve the localization service and its translation function
        const _ = this.app.getService('locale')._;
        // Define the date format based on application configuration
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat);
        // Get the current user parameter from the request
        const cur_user = this.getParam('user', true);
        // Preserve the context of 'this' for use in nested functions
        var vthis = this;
        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader element
                    cols: [
                        {
                            view: 'datatable', // Define a datatable view
                            id: 'datatable', // ID for the datatable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            height: screen.width < 500 ? 400 : 0, // Set height based on screen width
                            columns: [
                                {
                                    id: 'rating', // Column ID for rating
                                    header: '', // Column header
                                    width: 50, // Column width
                                    height: 25, // Column height
                                    tooltip: _('Editar'), // Tooltip for the column
                                    template: function(obj) {
                                        // Template function for rendering cell content
                                        if (devConfig.getPermAction('accountingExpensePrint', 'Edit')) {
                                            // Return icon if user has permission to edit
                                            return '<span class=\'webix_icon wxi-close printer\'></span>';
                                        } else {
                                            // Return empty string if no permission
                                            return '';
                                        }
                                    },
                                },
                                {
                                    id: 'Id', // Column ID for the item ID
                                    header: 'ID', // Column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    hidden: true, // Hide this column
                                },
                                {
                                    id: 'Consecutive', // Column ID for consecutive number
                                    header: _('Consecutivo'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Description', // Column ID for description
                                    header: _('Descripción'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'CreatedLocalDate', // Column ID for creation date
                                    header: _('Fecha de Creación'), // Column header with localization
                                    fillspace: 0, // Fill space option
                                    minWidth: 0, // Minimum width
                                    width: 150, // Column width
                                    sort: 'text', // Sorting type
                                    format: dateFormat, // Date format for display
                                },
                                {
                                    id: 'BetShop', // Column ID for point of sale
                                    header: _('Punto de Venta'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'UserCreated', // Column ID for creator
                                    header: _('Creador'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'DocumentID', // Column ID for document ID
                                    header: _('Documento ID'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Account', // Column ID for account
                                    header: _('Cuenta'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Concept', // Column ID for concept
                                    header: _('Concepto'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Amount', // Column ID for amount
                                    header: _('Valor'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Tax', // Column ID for tax
                                    header: _('Impuesto'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Retraction', // Column ID for retraction
                                    header: _('Retracción'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                            ],
                            onClick: {
                                edit: function(euv, id) {
                                    // Event handler for edit action
                                    $$('EditExpenses').show(); // Show the edit expenses window
                                },
                                printer: function(euv, id) {
                                    // Event handler for print action
                                    var vvthis = this; // Preserve context
                                    var item = vvthis.getItem(id); // Get the item associated with the clicked row
                                    webix
                                        .ajax() // Perform an AJAX request
                                        .headers({
                                            'Content-type': 'application/json', // Set content type for the request
                                        })
                                        .post(
                                            devConfig.geturlApi() + 'Accounting/GetDetailsExpensePDF', // API endpoint for fetching PDF details
                                            '{ "Id":' + item.Id + '}', // Request payload with item ID
                                            {
                                                error: function(text, data, XmlHttpRequest) {
                                                    webix.message(_('Error! ')); // Show error message on failure
                                                },
                                                success: function(text, data, XmlHttpRequest) {
                                                    data = JSON.parse(text); // Parse the response text
                                                    webix
                                                        .ui({
                                                            view: 'window', // Create a new window for displaying the PDF
                                                            head: {
                                                                view: 'toolbar', // Toolbar for the window
                                                                cols: [
                                                                    {
                                                                        view: 'label',
                                                                        label: _(
                                                                            'Soporte', // Label for the window
                                                                        ),
                                                                    },
                                                                    {
                                                                        view: 'button',
                                                                        label: 'X', // Close button
                                                                        width: 100,
                                                                        align: 'right',
                                                                        click: '$(\'windowfact2\').close();', // Close window action
                                                                    },
                                                                ],
                                                            },
                                                            id: 'windowfact2', // ID for the window
                                                            modal: true, // Make the window modal
                                                            position: 'center', // Center the window
                                                            body: {
                                                                rows: [
                                                                    {
                                                                        template:
                                                                            '<iframe src="" type="application/pdf" width="100%" height="100%" style="overflow: auto;"> </iframe>', // Template for displaying PDF
                                                                    },
                                                                ],
                                                            },
                                                        })
                                                        .show(); // Show the window
                                                    var reader = new FileReader(); // Create a FileReader to read the PDF data
                                                    reader.onload = function(event) {
                                                        $$('pdf').clear(); // Clear previous PDF data
                                                        $$('pdf').parse({
                                                            data: event.target.result, // Parse the result from FileReader
                                                        });
                                                    };

                                                    // Function to convert base64 to Blob
                                                    function b64toBlob(b64Data, contentType, sliceSize) {
                                                        contentType = contentType || ''; // Default content type
                                                        sliceSize = sliceSize || 512; // Default slice size
                                                        var byteCharacters = atob(b64Data); // Decode base64 string
                                                        var byteArrays = []; // Array to hold byte arrays
                                                        for (
                                                            var offset = 0;
                                                            offset < byteCharacters.length;
                                                            offset += sliceSize
                                                        ) {
                                                            var slice = byteCharacters.slice(
                                                                offset,
                                                                offset + sliceSize,
                                                            ); // Slice the byte characters
                                                            var byteNumbers = new Array(slice.length); // Create an array for byte numbers
                                                            for (var i = 0; i < slice.length; i++) {
                                                                byteNumbers[i] = slice.charCodeAt(
                                                                    i, // Convert each character to byte number
                                                                );
                                                            }
                                                            var byteArray = new Uint8Array(
                                                                byteNumbers, // Create a Uint8Array from byte numbers
                                                            );
                                                            byteArrays.push(
                                                                byteArray, // Push byte array to the array
                                                            );
                                                        }
                                                        var blob = new Blob(byteArrays, {
                                                            type: contentType, // Create a Blob with the byte arrays
                                                        });
                                                        return blob; // Return the Blob
                                                    }

                                                    var contentType = 'application/pdf'; // Define content type for PDF
                                                    var b64Data = data.Pdf; // Get base64 PDF data from response
                                                    var blob = b64toBlob(
                                                        b64Data,
                                                        contentType, // Convert base64 to Blob
                                                    );
                                                    var file = window.URL.createObjectURL(
                                                        blob, // Create a URL for the Blob
                                                    );
                                                    console.log(blob); // Log the Blob for debugging
                                                    document.querySelector('iframe').src = file; // Set the iframe source to the Blob URL
                                                    var printWindow = window.open(
                                                        file,
                                                        '',
                                                        'width=800,height=500', // Open a new window for printing
                                                    );
                                                    printWindow.print(); // Trigger print dialog
                                                },
                                            },
                                        );
                                },
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: 0, // Set load ahead option
                            datafetch: devConfig.getDefaultDataFetch(), // Fetch default data
                            pager: 'pagerA', // Set pager ID for pagination
                        },
                    ],
                },
            ],
        }; // Placeholder for the configuration content of the view
    }

    /**
     * Initializes the view and its components.
     * @param {Object} grid - The grid component to be initialized.
     */
    init(grid) {
        // Retrieve the localization service from the app instance
        const _ = this.app.getService('locale')._;
        // Get the data table component
        grid = $$('datatable');
        // Get the current user parameter from the request
        const cur_user = this.getParam('user', true);
        // Construct the API URL for fetching expenses, including the current user ID
        var url = devConfig.geturlApi() + 'BetShop/GetExpenses?FromId=' + cur_user + '&';
        // Initialize a filter variable for future use
        var filter = '';
        // Arrays to hold date values for popups
        var datePopup3 = [];
        var datePopup4 = [];
        // Variable to hold the content for an add popup
        var popupAdd = '';
        // Create a string representing the current local date in 'YYYY:MM:DD' format
        var createdLocalDate =
            webix.Date.add(new Date(), -0, 'day').getFullYear() +
            ':' +
            ('00' + (webix.Date.add(new Date(), -0, 'day').getMonth() + 1)).slice(-2) +
            ':' +
            ('00' + webix.Date.add(new Date(), -0, 'day').getDate()).slice(-2);
        // Perform an AJAX request with specified headers
        webix
            .ajax()
            .headers({
                // Set the content type to JSON for the request
                'Content-type': 'application/json',
            })
            .post(devConfig.geturlApi() + 'Accounting/GetConceptsSelect', '', {
                error: function(text, data, XmlHttpRequest) {
                    webix.message(_('Error! ')); // Displays an error message.
                },
                success: function(text, data, XmlHttpRequest) {
                    var resp = JSON.parse(text); // Parses the JSON response.
                    datePopup3 = resp.Data; // Stores the data in the datePopup3 variable.

                    /**
                     * Sends another AJAX request to fetch types of center position data.
                     */
                    webix
                        .ajax()
                        .headers({
                            'Content-type': 'application/json', // Sets the content type for the request.
                        })
                        .post(devConfig.geturlApi() + 'Accounting/GetTypesCenterPositionSelect', '{"Type":2}', {
                            /**
                             * Handles the error response for the second AJAX request.
                             * @param {string} text - The error message text.
                             * @param {Object} data - The data object returned from the server.
                             * @param {XMLHttpRequest} XmlHttpRequest - The XMLHttpRequest object.
                             */
                            error: function(text, data, XmlHttpRequest) {
                                webix.message(_('Error! ')); // Displays an error message.
                            },

                            /**
                             * Handles the success response for the second AJAX request.
                             * @param {string} text - The response text from the server.
                             * @param {Object} data - The data object returned from the server.
                             * @param {XMLHttpRequest} XmlHttpRequest - The XMLHttpRequest object.
                             */
                            success: function(text, data, XmlHttpRequest) {
                                var resp = JSON.parse(text); // Parses the JSON response.
                                datePopup4 = resp.Data; // Stores the data in the datePopup4 variable.

                                /**
                                 * Configures and initializes the popup for adding expenses.
                                 */
                                popupAdd = webix.ui({
                                    view: 'window', // Defines the popup as a window.
                                    width: 750, // Sets the width of the popup.
                                    id: 'AddExpenses', // Unique ID for the popup.
                                    head: {
                                        view: 'toolbar', // Toolbar for the popup header.
                                        cols: [
                                            {
                                                view: 'label', // Label for the popup title.
                                                label: _('Añadir Gasto'),
                                            },
                                            {
                                                view: 'icon', // Close icon for the popup.
                                                icon: 'wxi-close',
                                                click: function() {
                                                    this.getTopParentView().hide(); // Hides the popup on click.
                                                },
                                            },
                                        ],
                                    },
                                    position: 'center', // Centers the popup on the screen.
                                    modal: true, // Enables modal behavior for the popup.
                                    body: {
                                        view: 'form', // Defines the body as a form.
                                        id: 'addform', // Unique ID for the form.
                                        elements: [
                                            {
                                                margin: 10, // Sets the margin for the form elements.
                                                cols: [
                                                    {
                                                        view: 'text', // Text input for the description.
                                                        label: _('Descripción'),
                                                        name: 'Description',
                                                        labelWidth: 140,
                                                        required: true, // Marks the field as required.
                                                    },
                                                    {
                                                        view: 'text', // Text input for the creation date.
                                                        label: _('Fecha de Creación'),
                                                        labelWidth: 140,
                                                        name: 'CreatedLocalDate',
                                                        value: createdLocalDate, // Pre-fills the field with the current date.
                                                        readonly: true, // Makes the field read-only.
                                                    },
                                                ],
                                            },
                                            {
                                                margin: 10,
                                                cols: [
                                                    {
                                                        view: 'combo', // Dropdown for selecting the type of expense.
                                                        label: _('Tipo de Egreso'),
                                                        name: 'TypeEgress',
                                                        labelWidth: 140,
                                                        options: datePopup4, // Options fetched from the server.
                                                        required: true,
                                                    },
                                                ],
                                            },
                                            {
                                                margin: 10,
                                                cols: [
                                                    {
                                                        view: 'combo', // Dropdown for selecting the concept.
                                                        label: _('Concepto'),
                                                        name: 'Concept',
                                                        labelWidth: 140,
                                                        options: datePopup3, // Options fetched from the server.
                                                        required: true,
                                                    },
                                                    {
                                                        view: 'text', // Text input for the document ID.
                                                        label: _('Documento ID'),
                                                        name: 'DocumentID',
                                                        labelWidth: 140,
                                                        required: false,
                                                    },
                                                ],
                                            },
                                            {
                                                margin: 10,
                                                cols: [
                                                    {
                                                        view: 'text', // Text input for the value.
                                                        label: _('Valor'),
                                                        name: 'Value',
                                                        type: 'number', // Numeric input.
                                                        labelWidth: 100,
                                                        required: true,
                                                    },
                                                    {
                                                        view: 'text', // Text input for the tax (IVA).
                                                        label: _('Impuesto'),
                                                        name: 'Iva',
                                                        type: 'number', // Numeric input.
                                                        labelWidth: 100,
                                                        required: true,
                                                    },
                                                    {
                                                        view: 'text', // Text input for the retraction.
                                                        label: _('Retracción'),
                                                        name: 'Retraccion',
                                                        type: 'number', // Numeric input.
                                                        labelWidth: 100,
                                                        required: true,
                                                    },
                                                ],
                                            },
                                            {
                                                cols: [
                                                    {
                                                        view: 'button', // Cancel button.
                                                        value: _('Cancelar'),
                                                        click: function() {
                                                            this.getTopParentView().hide(); // Hides the popup.
                                                            $$('addform').setValues($$('addform').getCleanValues()); // Resets the form.
                                                        },
                                                    },
                                                    {
                                                        view: 'button', // Save button.
                                                        type: 'form',
                                                        value: _('Guardar'),
                                                        click: function($e) {
                                                            var values = $$('addform').getValues(); // Retrieves form values.
                                                            if ($$('addform').validate()) {
                                                                // Validates the form.
                                                                webix
                                                                    .ajax()
                                                                    .headers({
                                                                        'Content-type': 'application/json', // Sets the content type.
                                                                    })
                                                                    .post(
                                                                        devConfig.geturlApi() + 'BetShop/Expenses', // API endpoint.
                                                                        '{"Description":"' +
                                                                        values.Description +
                                                                        '", "CreatedLocalDate":"' +
                                                                        values.CreatedLocalDate +
                                                                        '", "TypeEgress":"' +
                                                                        values.TypeEgress +
                                                                        '"  , "BetShop":"' +
                                                                        cur_user +
                                                                        '" , "Concept":"' +
                                                                        values.Concept +
                                                                        '" , "DocumentID":"' +
                                                                        values.DocumentID +
                                                                        '"  , "Value":"' +
                                                                        values.Value +
                                                                        '", "Iva":"' +
                                                                        values.Iva +
                                                                        '", "Retraccion":"' +
                                                                        values.Retraccion +
                                                                        '"}',
                                                                        {
                                                                            error: function(
                                                                                text,
                                                                                data,
                                                                                XmlHttpRequest,
                                                                            ) {
                                                                                webix.message(_('Error! '));
                                                                            },
                                                                            success: function(
                                                                                text,
                                                                                data,
                                                                                XmlHttpRequest,
                                                                            ) {
                                                                                webix.message(_('Gasto Agregado'));
                                                                                grid.clearAll();
                                                                                grid.load(
                                                                                    url +
                                                                                    '?start=0&count=' +
                                                                                    grid.data.$pagesize +
                                                                                    filter, // Reloads the grid with updated data.
                                                                                );
                                                                                webix
                                                                                    .ui({
                                                                                        view: 'window',
                                                                                        width: 500,
                                                                                        height: 700,
                                                                                        head: {
                                                                                            view: 'toolbar',
                                                                                            cols: [
                                                                                                {
                                                                                                    view: 'label',
                                                                                                    label: _('Factura'),
                                                                                                },
                                                                                                {
                                                                                                    view: 'button',
                                                                                                    label: 'X',
                                                                                                    width: 100,
                                                                                                    align: 'right',
                                                                                                    click: '$(\'windowfact2\').close();',
                                                                                                },
                                                                                            ],
                                                                                        },
                                                                                        id: 'windowfact2',
                                                                                        modal: true,
                                                                                        position: 'center',
                                                                                        body: {
                                                                                            rows: [
                                                                                                {
                                                                                                    template:
                                                                                                        '<iframe src="" type="application/pdf" width="100%" height="100%" style="overflow: auto;"> </iframe>',
                                                                                                },
                                                                                            ],
                                                                                        },
                                                                                    })
                                                                                    .show();
                                                                                var reader = new FileReader();
                                                                                reader.onload = function(event) {
                                                                                    $$('pdf').clear();
                                                                                    $$('pdf').parse({
                                                                                        data: event.target.result,
                                                                                    });
                                                                                };

                                                                                function b64toBlob(
                                                                                    b64Data,
                                                                                    contentType,
                                                                                    sliceSize,
                                                                                ) {
                                                                                    contentType = contentType || '';
                                                                                    sliceSize = sliceSize || 512;
                                                                                    var byteCharacters = atob(b64Data);
                                                                                    var byteArrays = [];
                                                                                    for (
                                                                                        var offset = 0;
                                                                                        offset < byteCharacters.length;
                                                                                        offset += sliceSize
                                                                                    ) {
                                                                                        var slice =
                                                                                            byteCharacters.slice(
                                                                                                offset,
                                                                                                offset + sliceSize,
                                                                                            );
                                                                                        var byteNumbers = new Array(
                                                                                            slice.length,
                                                                                        );
                                                                                        for (
                                                                                            var i = 0;
                                                                                            i < slice.length;
                                                                                            i++
                                                                                        ) {
                                                                                            byteNumbers[i] =
                                                                                                slice.charCodeAt(i);
                                                                                        }
                                                                                        var byteArray = new Uint8Array(
                                                                                            byteNumbers,
                                                                                        );
                                                                                        byteArrays.push(byteArray);
                                                                                    }
                                                                                    var blob = new Blob(byteArrays, {
                                                                                        type: contentType,
                                                                                    });
                                                                                    return blob;
                                                                                }

                                                                                var contentType = 'application/pdf';
                                                                                var b64Data = data.Pdf;
                                                                                var blob = b64toBlob(
                                                                                    b64Data,
                                                                                    contentType,
                                                                                );
                                                                                var file =
                                                                                    window.URL.createObjectURL(blob);
                                                                                console.log(blob);
                                                                                document.querySelector('iframe').src =
                                                                                    file;
                                                                                var printWindow = window.open(
                                                                                    file,
                                                                                    '',
                                                                                    'width=800,height=500',
                                                                                );
                                                                                printWindow.print();
                                                                            },
                                                                        },
                                                                    );
                                                                $$('addform').setValues($$('addform').getCleanValues()); // Resets the form.
                                                                this.getTopParentView().hide(); // Hides the popup.
                                                            } else {
                                                                webix.message({
                                                                    title: _('¡Error!'),
                                                                    type: 'alert-error',
                                                                    text: _('Completa los campos...'), // Displays a validation error message.
                                                                });
                                                            }
                                                        },
                                                    },
                                                ],
                                            },
                                        ],
                                        elementsConfig: {
                                            on: {
                                                /**
                                                 * Validates the form on change.
                                                 */
                                                onChange: function() {
                                                    this.validate();
                                                },
                                            },
                                        },
                                    },
                                });
                            },
                        });
                },
            });

        // Event listener for 'expense:filter' event on the app instance
        this.on(this.app, 'expense:filter', (filterData) => {
            // Convert filterData object into an array of key-value pairs
            var object = Object.entries(filterData);
            var string1 = ''; // Initialize query string

            // Iterate through each key-value pair in the filterData
            for (var i = 0; i < object.length; i++) {
                // Check if the value is not an object and is not an empty string
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Handle date range from Datepicker
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add start date to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date to query
                    } else {
                        // Handle single date values
                        if (object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to query
                        } else {
                            // Handle specific case for 'Date'
                            if (object[i][0] == 'Date') {
                                var date = object[i][1].replace(
                                    ' 00:00:00',
                                    '', // Remove time from date string
                                );
                                string1 = string1 + '&dateFrom=' + date; // Add date to query
                                string1 = string1 + '&dateTo=' + date; // Add date to query
                            }
                        }
                    }
                } else {
                    // Handle cases where the value is an object
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to array
                        // Iterate through each key-value pair in the nested object
                        for (var j = 0; j < object2.length; j++) {
                            // Check if the value is not null
                            if (object2[j][1] !== null) {
                                // Handle start date
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Create date object from value
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) + // Format month
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) + // Format day
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) + // Format hours
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) + // Format minutes
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format seconds
                                    string1 = string1 + '&' + dateFrom; // Add start date to query
                                } else {
                                    // Handle end date
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Create date object from value
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) + // Format month
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) + // Format day
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) + // Format hours
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) + // Format minutes
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format seconds
                                        string1 = string1 + '&' + dateTo; // Add end date to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&FromId=' + cur_user; // Append current user ID to query
            grid.clearAll(); // Clear existing grid data
            // Load new data into the grid with the constructed query string
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1);
            filter = string1; // Store the constructed filter string
        });
        // Attach an event handler for the 'onAfterSort' event of the grid
        grid.attachEvent('onAfterSort', function(by, dir, as) {
            // Load the grid data with sorting parameters after sorting is completed
            grid.load(
                url +
                '?start=0&count=' +
                grid.data.$pagesize + // Set the starting index and page size
                filter + // Include any additional filters
                '&sort[' +
                by + // Specify the field to sort by
                ']=' +
                dir, // Specify the direction of sorting (ascending/descending)
            );
        });

        // Attach an event handler for the 'onItemClick' event of the grid
        grid.attachEvent('onItemClick', function(id, e, node) {
            var item = this.getItem(id); // Retrieve the clicked item using its ID
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger an event with the item's ID
        });

        // Listen for the 'player:select' event from the app
        this.on(this.app, 'player:select', (Id) => {
            // Load the grid data filtered by the selected player's ID
            grid.load(
                grid.data.url +
                '?start=0&count=' +
                grid.data.$pagesize + // Set the starting index and page size
                '&PlayerId=' +
                Id, // Include the selected player's ID as a filter
            );
        });
        // Create a popup window for editing expenses
        var popup = webix.ui({
            view: 'window', // Define the view type as a window
            width: 750, // Set the width of the window
            id: 'EditExpenses', // Unique identifier for the window
            head: {
                // Header configuration
                view: 'toolbar', // Define the header as a toolbar
                cols: [
                    // Columns in the toolbar
                    { view: 'label', label: _('Editar Gasto') }, // Label for the window title
                    {
                        view: 'icon', // Icon button to close the window
                        icon: 'wxi-close', // Icon type
                        click: function() {
                            // Click event handler
                            this.getTopParentView().hide(); // Hide the window on click
                        },
                    },
                ],
            },
            position: 'center', // Center the window on the screen
            modal: true, // Make the window modal
            body: {
                // Body configuration of the window
                view: 'form', // Define the body as a form
                id: 'editForm', // Unique identifier for the form
                elements: [
                    // Form elements
                    {
                        margin: 10, // Margin around the element
                        cols: [
                            // Columns in the first row
                            {
                                view: 'text', // Text input for ID
                                label: 'ID', // Label for the input
                                name: 'Id', // Name of the input field
                                readonly: true, // Make the input read-only
                                labelWidth: 140, // Width of the label
                            },
                            {
                                view: 'text', // Text input for Description
                                label: _('Descripción'), // Label for the input
                                name: 'Description', // Name of the input field
                                labelWidth: 140, // Width of the label
                            },
                        ],
                    },
                    {
                        margin: 10, // Margin around the element
                        cols: [
                            // Columns in the second row
                            {
                                view: 'text', // Text input for Created Local Date
                                label: _('Fecha de Creación'), // Label for the input
                                labelWidth: 140, // Width of the label
                                name: 'CreatedLocalDate', // Name of the input field
                                readonly: true, // Make the input read-only
                            },
                            {
                                view: 'text', // Text input for Type of Egress
                                label: _('Tipo de Egreso'), // Label for the input
                                name: 'TypeEgress', // Name of the input field
                                readonly: true, // Make the input read-only
                                labelWidth: 140, // Width of the label
                            },
                        ],
                    },
                    {
                        margin: 10, // Margin around the element
                        cols: [
                            // Columns in the third row
                            {
                                view: 'text', // Text input for Document ID
                                label: _('Documento ID'), // Label for the input
                                name: 'DocumentID', // Name of the input field
                                readonly: true, // Make the input read-only
                                labelWidth: 140, // Width of the label
                            },
                        ],
                    },
                    {
                        margin: 10, // Margin around the element
                        cols: [
                            // Columns in the fourth row
                            {
                                view: 'combo', // Combo box for Concept
                                label: _('Concepto'), // Label for the input
                                name: 'Concept', // Name of the input field
                                labelWidth: 140, // Width of the label
                                readonly: true, // Make the input read-only
                            },
                            {
                                view: 'text', // Text input for Value
                                label: _('Valor'), // Label for the input
                                name: 'Value', // Name of the input field
                                type: 'number', // Input type is number
                                labelWidth: 140, // Width of the label
                            },
                        ],
                    },
                    {
                        margin: 10, // Margin around the element
                        cols: [
                            // Columns in the fifth row
                            {
                                view: 'text', // Text input for Tax (Iva)
                                label: _('Impuesto'), // Label for the input
                                name: 'Iva', // Name of the input field
                                type: 'number', // Input type is number
                                labelWidth: 140, // Width of the label
                            },
                            {
                                view: 'text', // Text input for Retraction
                                label: _('Retracción'), // Label for the input
                                name: 'Retraccion', // Name of the input field
                                type: 'number', // Input type is number
                                labelWidth: 140, // Width of the label
                            },
                        ],
                    },
                    {
                        cols: [
                            // Columns for the buttons
                            {
                                view: 'button', // Button for Cancel
                                value: _('Cancelar'), // Button label
                                click: function() {
                                    // Click event handler
                                    this.getTopParentView().hide(); // Hide the window
                                   $$('editForm').setValues(
                                        // Reset form values
                                       $$('editForm').getCleanValues(),
                                    );
                                },
                            },
                            {
                                view: 'button', // Button for Save
                                type: 'form', // Button type is form
                                value: _('Guardar'), // Button label
                                click: function($e) {
                                    // Click event handler
                                    var values =$$('editForm').getValues(); // Get form values
                                    webix // Perform an AJAX request
                                        .ajax()
                                        .headers({
                                            'Content-type': 'application/json', // Set content type
                                        })
                                        .post(
                                            devConfig.geturlApi() + // API URL
                                            'BetShop/Expenses',
                                            '{"Id":"' +
                                            values.Id +
                                            '", "IsBetShop":"' +
                                            values.IsBetShop +
                                            '", "Description":"' +
                                            values.Description +
                                            '", "CreatedLocalDate":"' +
                                            values.CreatedLocalDate +
                                            '", "TypeEgress":"' +
                                            values.TypeEgress +
                                            '"  , "BetShop":"' +
                                            cur_user +
                                            '"  , "DocumentID":"' +
                                            values.DocumentID +
                                            '"  , "Value":"' +
                                            values.Value +
                                            '", "Iva":"' +
                                            values.Iva +
                                            '", "Retraccion":"' +
                                            values.Retraccion +
                                            '"}', // JSON payload
                                            {
                                                error: function(text, data, XmlHttpRequest) {
                                                    // Error handler
                                                    webix.message(_('Error! ')); // Show error message
                                                },
                                                success: function(text, data, XmlHttpRequest) {
                                                    // Success handler
                                                    webix.message(_('Gasto Actualizado')); // Show success message
                                                    grid.clearAll(); // Clear the grid
                                                    grid.load(
                                                        // Reload the grid data
                                                        url + '?start=0&count=' + grid.data.$pagesize + filter,
                                                    );
                                                },
                                            },
                                        );
                                   $$('editForm').setValues(
                                        // Reset form values
                                       $$('editForm').getCleanValues(),
                                    );
                                    this.getTopParentView().hide(); // Hide the window
                                },
                            },
                        ],
                    },
                ],
            },
        });
        // Event listener for the 'AddExpense:button' event on the application instance
        this.on(this.app, 'AddExpense:button', (filter) => {
            // Clears any validation messages on the 'addform' component
            $$('addform').clearValidation();
            // Displays the popup for adding an expense
            popupAdd.show();
        });
        // Binds the 'editForm' component to the 'datatable' component for data manipulation
       $$('editForm').bind($$('datatable')); // Placeholder for the initialization content of the view
    }
}

// FILE DOCUMENTED
